/* eslint-disable */
export default {
  participants: 'Deelnemers',
  host: '(Host)',
  removeParticipant: 'Deelnemer verwijderen',
  removeTitle: 'Deelnemer verwijderen',
  removeDescription: '{name} uit deze conference verwijderen?',
  confirmButtonText: 'Verwijderen',
  cancelButtonText: 'Annuleren',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
